import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

type TDownloadStatus = { loading: boolean; error: boolean };

const initialState = {
    isLoaderVisible: false,
    useNewFunctionalData: true,
    downloadStatus: { loading: false, error: false },
    toastConfig: { title: "", content: "", duration: 3000 },
};

export const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        setToastConfig: (state, action: PayloadAction<{ title: string; content: string; duration?: 3000 }>) => ({
            ...state,
            toastConfig: { ...state.toastConfig, ...action.payload },
        }),
        showLoader: (state, action: PayloadAction<boolean>) => ({
            ...state,
            isLoaderVisible: action.payload,
        }),
        hideLoader: (state, action: PayloadAction<boolean>) => ({
            ...state,
            isLoaderVisible: action.payload,
        }),
        updateDownloadStatus: (state, action: PayloadAction<TDownloadStatus>) => ({
            ...state,
            downloadStatus: action.payload,
        }),
        updateNewFunctionalData: (state, action: PayloadAction<boolean>) => ({
            ...state,
            useNewFunctionalData: action.payload,
        }),
    },
});

// Actions
export const { showLoader, hideLoader, updateDownloadStatus, setToastConfig, updateNewFunctionalData } =
    uiSlice.actions;

// Selectors
export const getLoaderState = (state: RootState): boolean => state.ui.isLoaderVisible;
export const getDownloadStatusState = (store: RootState): TDownloadStatus => store.ui.downloadStatus;
export const getToastConfig = (state: RootState): typeof initialState["toastConfig"] => state.ui.toastConfig;
export const getUseNewFunctionalData = (state: RootState): boolean => state.ui.useNewFunctionalData;

// Operations
export const toggleLoader = (value: boolean): PayloadAction<boolean> => (value ? showLoader(value) : hideLoader(value));

export default uiSlice.reducer;
